//changed due to package upgrade
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import AppScrollbar from '../../../AppScrollbar';
import MainSidebar from '../../components/MainSidebar';
import Drawer from '@mui/material/Drawer';
import VerticalNav from '../../components/VerticalNav';
import SidebarWrapper from './SidebarWrapper';
import { useLayoutContext } from '@projectK/context/LayoutContextProvider';
import UserInfo from '../../components/UserInfo';
import { useSidebarContext } from '@projectK/context/SidebarContextProvider';
import { useMediaQuery, useTheme } from '@mui/material';

const AppSidebar = (props) => {
  const { footer, footerType } = useLayoutContext();
  const theme = useTheme();
  const isxlUp = useMediaQuery(theme.breakpoints.up(' xl'));
  const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const { sidebarTextColor } = useSidebarContext();

  return (
    <>
      {!isxlUp && (
        <Drawer
          anchor={props.position}
          open={props.isNavCollapsed}
          onClose={props.toggleNavCollapsed}
          classes={{
            root: clsx(props.variant),
            paper: clsx(props.variant),
          }}
          style={{ position: 'absolute' }}
        >
          <SidebarWrapper className='mini-sidebar'>
            <MainSidebar>
              <UserInfo color={sidebarTextColor} />
              <AppScrollbar
                sx={{
                  py: 2,
                  height: 'calc(100vh - 70px) !important',
                }}
                scrollToTop={false}
              >
                <VerticalNav routesConfig={props.routesConfig} />
              </AppScrollbar>
            </MainSidebar>
          </SidebarWrapper>
        </Drawer>
      )}
      {!isLgDown && (
        <SidebarWrapper className='mini-sidebar'>
          <MainSidebar>
            <UserInfo color={sidebarTextColor} />
            <AppScrollbar
              className={clsx({
                'has-footer-fixed': footer && footerType === 'fixed',
              })}
              sx={{
                py: 2,
                height: 'calc(100vh - 70px) !important',
                '&.has-footer-fixed': {
                  height: 'calc(100vh - 117px) !important',
                },
              }}
              scrollToTop={false}
            >
              <VerticalNav routesConfig={props.routesConfig} />
            </AppScrollbar>
          </MainSidebar>
        </SidebarWrapper>
      )}
    </>
  );
};
export default AppSidebar;

AppSidebar.defaultProps = {
  variant: '',
  position: 'left',
};

AppSidebar.propTypes = {
  position: PropTypes.string,
  variant: PropTypes.string,
  toggleNavCollapsed: PropTypes.func,
  isNavCollapsed: PropTypes.bool,
  routesConfig: PropTypes.array,
};
